/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Triple_Coin_Item_DescriptionInputs */

const en_triple_coin_item_description = /** @type {(inputs: Triple_Coin_Item_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triple your coin reward after every focus session`)
};

const ar_triple_coin_item_description = /** @type {(inputs: Triple_Coin_Item_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ضاعف مكافأتك من العملات ثلاث مرات بعد كل جلسة تركيز`)
};

const de_triple_coin_item_description = /** @type {(inputs: Triple_Coin_Item_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verdreifache deine Münzen-Belohnung nach jeder Fokussitzung`)
};

const es_triple_coin_item_description = /** @type {(inputs: Triple_Coin_Item_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triplica tu recompensa en monedas después de cada sesión de concentración`)
};

const fr_triple_coin_item_description = /** @type {(inputs: Triple_Coin_Item_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triple ta récompense en pièces après chaque session de concentration`)
};

const it_triple_coin_item_description = /** @type {(inputs: Triple_Coin_Item_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triplica la tua ricompensa in monete dopo ogni sessione di concentrazione`)
};

const ja_triple_coin_item_description = /** @type {(inputs: Triple_Coin_Item_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中セッションのたびにコイン報酬が3倍に`)
};

const ko_triple_coin_item_description = /** @type {(inputs: Triple_Coin_Item_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중 세션마다 코인 보상이 3배로`)
};

const pt_br_triple_coin_item_description = /** @type {(inputs: Triple_Coin_Item_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triplique sua recompensa em moedas após cada sessão de foco`)
};

const ru_triple_coin_item_description = /** @type {(inputs: Triple_Coin_Item_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Утрой награду в монетах после каждой сессии фокусировки`)
};

const th_triple_coin_item_description = /** @type {(inputs: Triple_Coin_Item_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รับเหรียญรางวัลเพิ่มเป็น 3 เท่าหลังจบทุกเซสชันโฟกัส`)
};

const tr_triple_coin_item_description = /** @type {(inputs: Triple_Coin_Item_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her odaklanma seansından sonra jeton ödülünü üçe katla`)
};

const zh_cn_triple_coin_item_description = /** @type {(inputs: Triple_Coin_Item_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每次专注后金币奖励 x3`)
};

const zh_tw_triple_coin_item_description = /** @type {(inputs: Triple_Coin_Item_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每次專注後金幣獎勵 x3`)
};

/**
* | output |
* | --- |
* | "Triple your coin reward after every focus session" |
*
* @param {Triple_Coin_Item_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const triple_coin_item_description = /** @type {((inputs?: Triple_Coin_Item_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Triple_Coin_Item_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_triple_coin_item_description(inputs)
	if (locale === "ar") return ar_triple_coin_item_description(inputs)
	if (locale === "de") return de_triple_coin_item_description(inputs)
	if (locale === "es") return es_triple_coin_item_description(inputs)
	if (locale === "fr") return fr_triple_coin_item_description(inputs)
	if (locale === "it") return it_triple_coin_item_description(inputs)
	if (locale === "ja") return ja_triple_coin_item_description(inputs)
	if (locale === "ko") return ko_triple_coin_item_description(inputs)
	if (locale === "pt_br") return pt_br_triple_coin_item_description(inputs)
	if (locale === "ru") return ru_triple_coin_item_description(inputs)
	if (locale === "th") return th_triple_coin_item_description(inputs)
	if (locale === "tr") return tr_triple_coin_item_description(inputs)
	if (locale === "zh_cn") return zh_cn_triple_coin_item_description(inputs)
	return zh_tw_triple_coin_item_description(inputs)
});